var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedWa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 124 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#59A452",
    x: 15,
    y: 6,
    width: 109,
    height: 31,
    rx: 4
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "LucidaGrande, Lucida Grande",
    fontSize: 20,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 50,
    y: 29
  }, "SHARE")), /*#__PURE__*/React.createElement("path", {
    d: "M11.403 37.384l.662.414a18.62 18.62 0 009.897 2.859c10.31 0 18.695-8.387 18.695-18.695S32.272 3.268 21.962 3.268c-10.308 0-18.694 8.386-18.694 18.694 0 4.194 1.374 8.168 3.97 11.491l.46.587-.962 4.951 4.667-1.607zm10.559 6.54a21.863 21.863 0 01-10.954-2.948l-8.556 2.949 1.757-9.062A21.718 21.718 0 010 21.962C0 9.852 9.852 0 21.962 0s21.963 9.852 21.963 21.962-9.852 21.963-21.963 21.963z",
    fill: "#59A452"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 23,
    cy: 22,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 13.524s1.29-2.252 2.34-2.381c1.05-.13 2.402-.13 2.766.558.365.686 1.995 4.677 1.995 4.677s.28.686-.15 1.351c-.428.665-1.393 1.63-1.393 1.63s-.537.687 0 1.417c.536.728 1.368 2.07 3.09 3.789 1.718 1.72 5.018 2.947 5.018 2.947s.473.064.774-.236c.3-.3 1.93-2.338 1.93-2.338s.524-.675 1.394-.279c.869.397 4.634 2.274 4.634 2.274s.44.16.44.826c0 .665-.269 2.292-.82 2.842-.55.55-2.158 2.247-4.576 2.247-2.417 0-8.174-1.968-11.242-5.035-3.068-3.069-5.792-6.18-6.435-9.01-.644-2.833-.558-4.113.235-5.279",
    fill: "#59A452"
  }))));
}
export default SvgSelectedWa;